import { LazyMotion, domMax } from 'framer-motion';
import React from 'react';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

function MotionLazy({ children }: Props) {
  return (
    <LazyMotion features={domMax} strict>
      {children}
    </LazyMotion>
  );
}

export default React.memo(MotionLazy);
